'use client';

import {safeSessionStorage} from '@utils/safeStorages';
import {usePathname} from 'next/navigation';
import {useEffect} from 'react';

export const NAVIGATE_HISTORY = 'navigationHistory';

export const HistoryLayout = ({children}: {children: React.ReactNode}) => {
  const pathname = usePathname() as string;

  useEffect(() => {
    const currHistory = safeSessionStorage.getItem(NAVIGATE_HISTORY);

    if (!currHistory) {
      safeSessionStorage.setItem(NAVIGATE_HISTORY, JSON.stringify([pathname]));
    } else {
      try {
        const history = JSON.parse(currHistory);

        if (pathname !== history[history.length - 1]) {
          safeSessionStorage.setItem(
            NAVIGATE_HISTORY,
            JSON.stringify([...history, pathname]),
          );
        }
      } catch (e) {
        safeSessionStorage.setItem(
          NAVIGATE_HISTORY,
          JSON.stringify([pathname]),
        );
      }
    }
  }, [pathname]);

  return children;
};
